/**
 * ファイル出力のユーティリティクラス
 */

export default class OutputFileUtil {
  // 終了後にメッセージを出すケース(一部ブラウザ非対応)
  static async saveFileWithEvent(
    fileName: string,
    fileData: string,
    onSuccess?: () => void,
    onCancel?: () => void,
    onError?: (error: any) => void
  ): Promise<void> {
    const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
    const blob = new Blob([bom, fileData], { type: 'text/plain;charset=utf-8' });

    try {
      const handle = await (window as any).showSaveFilePicker({
        suggestedName: fileName,
        types: [{
          accept: {
            'text/csv': ['.csv'],
          },
        }],
      });

      const writable = await handle.createWritable();
      await writable.write(blob);
      await writable.close();

      // 成功
      if (onSuccess) onSuccess();

    } catch (error: any) {
      if (error.name === 'AbortError') {
        // キャンセル
        if (onCancel) onCancel();
      } else {
        // 失敗
        if (onError) onError(error);
      }
    }
  }

  /**
    * @brief	ファイル出力（文字列指定）
    * @note   UTF-8(BOM付き)で出力します
    * @param  [in]    fileName        ファイル名
    * @param  [in]    fileData        出力内容
    */
  static OutputFile(fileName: string, fileData: string): void {
    // UTF-8 BOM付き
    const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
    const blob = new Blob([bom, fileData]);

    // HTMLのaタグを作成し、ファイルをダウンロードする
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    // 実行
    link.click();

    // URLを解除
    URL.revokeObjectURL(link.href);
  }

  /**
    * @brief	ファイル出力（バイナリ指定）
    * @param  [in]    fileName        ファイル名
    * @param  [in]    fileData        出力内容
    */
  static OutputFileBinary(fileName: string, fileData: Uint8Array): void {
    const blob = new Blob([fileData]);

    // HTMLのaタグを作成し、ファイルをダウンロードする
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    // 実行
    link.click();

    // URLを解除
    URL.revokeObjectURL(link.href);
  }

  /**
    * @brief	ファイル出力（文字列指定）UTF-8(BOMなし)
    * @note   UTF-8(BOMなし)で出力します
    * @param  [in]    fileName        ファイル名
    * @param  [in]    fileData        出力内容
    */
  static OutputFileUTF8N(fileName: string, fileData: string): void {
    // UTF-8 BOMなし
    const blob = new Blob([fileData]);

    // HTMLのaタグを作成し、ファイルをダウンロードする
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    // 実行
    link.click();

    // URLを解除
    URL.revokeObjectURL(link.href);
  }
}

